import { Flex, Divider } from "@chakra-ui/react";
import DescricaoConta from "./components/DescricaoConta/index";
import colors from "core/resources/theme/colors";
import {
  ContaItemResponse,
  ContaPagarMultiplasContasForm,
} from "features/conta/typings";
import ContentRight from "./components/ContentRight/index";
import useFindContaEncargosAtraso from "core/features/conta/hooks/useFindContaEncargos";
import { Control, UseFormSetValue } from "react-hook-form";
import { PagarMultiplasContasForm } from "core/features/conta/typings";
import { OperacaoEnum } from "core/resources/enums/conta";
import { useEffect, useMemo } from "react";

interface ItemContaLiquidarProps {
  item: ContaItemResponse;
  formItem?: ContaPagarMultiplasContasForm;
  taxaAdicionalCategoriaOperacao?: OperacaoEnum;
  index: number;
  dataPagamento: string;
  control: Control<PagarMultiplasContasForm, any>;
  operacao?: OperacaoEnum | undefined;
  setValue: UseFormSetValue<PagarMultiplasContasForm>;
  setLoadingEncargos?: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

export default function ItemContaLiquidar({
  item,
  index,
  dataPagamento,
  control,
  operacao,
  setValue,
  formItem,
  taxaAdicionalCategoriaOperacao,
  setLoadingEncargos,
}: ItemContaLiquidarProps) {
  const {
    data: dataEncargos,
    isLoading: isLoadingEncargos,
    isFetching: isFetchingEncargos,
  } = useFindContaEncargosAtraso(
    item.id,

    dataPagamento,
    operacao === OperacaoEnum.Receita
  );

  useEffect(() => {
    if (dataEncargos) {
      setValue(`contas.${index}`, {
        id: item.id,
        juros: dataEncargos.juros,
        multa: dataEncargos.multa,
        valor: item.valorOriginal,
      });
    }
  }, [dataEncargos, index, item, setValue]);

  const isLoading = useMemo(
    () => isLoadingEncargos || isFetchingEncargos,
    [isLoadingEncargos, isFetchingEncargos]
  );

  useEffect(() => {
    setLoadingEncargos?.((state) => ({ ...state, [item.id]: isLoading }));
  }, [isLoading, item.id, setLoadingEncargos]);

  const isTaxaAdicionalNegativa =
    (formItem?.taxaAdicional || 0) * (taxaAdicionalCategoriaOperacao || 0) < 0;

  const isTaxaAdicionalPositiva =
    (formItem?.taxaAdicional || 0) * (taxaAdicionalCategoriaOperacao || 0) > 0;

  const totalEncargos = isTaxaAdicionalNegativa
    ? formItem?.taxaAdicional ?? 0
    : 0;

  const totalAcrescimos =
    (formItem?.juros || 0) +
    (formItem?.multa || 0) +
    (isTaxaAdicionalPositiva ? formItem?.taxaAdicional ?? 0 : 0);

  return (
    <Flex
      px={3}
      border={`1px solid ${colors.lightGray}`}
      rounded={15}
      mt={index > 0 ? 4 : 0}
    >
      <Flex flexDirection="column" flex={4} py={2}>
        <DescricaoConta
          control={control}
          item={item}
          isLoading={isLoading}
          index={index}
          operacao={operacao}
        />
      </Flex>
      <Flex mx={4}>
        <Divider orientation="vertical" />
      </Flex>
      <Flex flex={1.2} py={4}>
        <ContentRight
          valor={item.valorOriginal}
          valorPago={item.valorOriginal + totalAcrescimos}
          valorLiquido={item.valorOriginal + totalAcrescimos - totalEncargos}
          isLoading={isLoading}
          encargos={totalEncargos}
          acrescimos={totalAcrescimos}
        />
      </Flex>
    </Flex>
  );
}
